export default __webpack_public_path__ + "static/media/about_neopin.24e52eb3.jpg";